import { CSSProperties } from 'react';

export enum WhoOptions {
    NONE = '',
    INSURANCE = 'Insurance',
    CONSULTING = 'Consulting',
    ENERGY_OFFSHORE = 'EnergyOffshore',
    MARINE_ENERGY = 'MarineEnergyInsurance',
    CAPTIVE = 'CaptiveInsurance',
    PROPERTY_CASUALTY = 'PropertyCasualtyInsurance',
}
export interface ContactFormData {
    firstName: string;
    lastName?: string;
    email: string;
    company?: string;
    message?: string;
    who?: WhoOptions;
}

export interface ContactProps {
    extraStyles?: CSSProperties;
}
